<template>
  <tr>
    <td colspan="3" class="productForm__serviceTable__sectionHeaderContainer text-left">
      <span class="productForm__serviceTable__sectionHeader">
        {{ header }}
        <span v-if="isNew" class="new-badge">
          Nowość!
        </span>
      </span>
      <slot name="description"></slot>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'NDEConfectionHeaderForm',
  props: {
    header: {
      type: String,
      required: true,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
